import r from "camelcase";
const i = "-", l = "_";
function h(t) {
  if (Array.isArray(t)) {
    for (let e = 0; e < t.length; e++)
      t[e] = typeof t[e] == "string" ? r(t[e]) : "";
    return t.join(l);
  } else
    return typeof t == "string" ? r(t) : "";
}
function f(...t) {
  for (let n = 0; n < t.length; n += 1)
    t[n] = h(t[n]);
  let e = t.join(i);
  if (e.length > 40) {
    const n = e.length - 40, o = t[t.length - 1];
    if (o.length > n)
      t[t.length - 1] = o.substr(
        0,
        o.length - n
      ), e = t.join(i);
    else
      throw new Error(
        "The data event value cannot have more than 40 characters"
      );
  }
  return e;
}
export {
  f as g
};
